import format from 'date-fns/format'
import addDays from 'date-fns/addDays'
import isWeekend from 'date-fns/isWeekend'

import { HOLIDAY_LIST } from '../constants/holiday'

function isHoliday(targetDate) {
  return HOLIDAY_LIST.includes(format(targetDate, 'yyyy/MM/dd'))
}

export function calcPaymentDate(tradeDate) {
  let paymentDate = new Date(tradeDate.getTime())
  while (true) {
    if (isWeekend(paymentDate) || isHoliday(paymentDate)) {
      // 土日・祝のいずれか
      paymentDate = addDays(paymentDate, 1)
      continue
    }
    break
  }
  return paymentDate
}
